import { render } from "./SignedWebhookCard.vue?vue&type=template&id=22f4c4f9&scoped=true"
import script from "./SignedWebhookCard.vue?vue&type=script&lang=js"
export * from "./SignedWebhookCard.vue?vue&type=script&lang=js"

import "./SignedWebhookCard.vue?vue&type=style&index=0&id=22f4c4f9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f4c4f9"]])

export default __exports__